<template>
  <div class="app">
    <seu-main-header
      @selectLanguage="selectLanguage"
    />

    <seu-header-mobile
      :menu-opened="menuOpened"
      @openMenu="menuOpened=true"
      @closeMenu="menuOpened=false"
    />

    <Transition name="mobile-menu">
      <mobile-menu
        v-if="menuOpened"
        :menu-opened="menuOpened" c
        @closeMenu="menuOpened=false"
        @selectLanguage="selectLanguage"
        @openPopup="openPopup"
      />
    </Transition>

    <router-view @openPopup="openPopup"/>

    <footer-section
      @openPopup="openPopup"
    />

    <vi-popup
      v-model="showPopup"
      :popup-class="popup==='TERMS' ? 'popup-wide' : ''"
    >
      <arrival v-if="popup === 'ARRIVAL'"/>
      <media v-else-if="popup==='MEDIA'"/>
      <newsletter v-else-if="popup==='NEWSLETTER'" @subscribed="showPopup = false"/>
      <jobs v-else-if="popup==='JOBS'"/>
      <impressum v-else-if="popup==='IMPRESSUM'"/>
      <terms v-else-if="popup==='TERMS'"
             :fields="termsContent.sections.cookies_banner_section.fields"
      />
    </vi-popup>

    <cookies-banner
      :fields="cookiesBannerContent.sections.cookies_banner_section.fields"
      @openPolicyPopup="openPopup('TERMS')"
    />

  </div>
</template>

<script>
import SeuMainHeader from "./sections/general/SeuMainHeader";
import {mapState} from "vuex";
import SeuHeaderMobile from "/seu-frontend/sections/general/SeuHeaderMobile";
import MobileMenu from "/seu-frontend/sections/general/MobileMenu";
import FooterSection from "/seu-frontend/sections/general/FooterSection";
import navigationMenu from "./services/data/navigationMenu";
import ViPopup from "/seu-frontend/components/common/ViPopup";
import Arrival from "seu-frontend/components/popups/Arrival"
import Media from "/seu-frontend/components/popups/Media";
import Newsletter from "/seu-frontend/components/popups/Newsletter";
import Jobs from "/seu-frontend/components/popups/Jobs";
import Impressum from "/seu-frontend/components/popups/Impressum";
import Terms from "/seu-frontend/components/popups/Terms";
import {subscribe} from "./services/newsletter"
import CookiesBanner from "/seu-frontend/components/common/CookiesBanner.vue";

export default {
  name: "App",
  components: {
    CookiesBanner,
    Terms,
    Impressum,
    Jobs, Newsletter, Media, Arrival, ViPopup, FooterSection, MobileMenu, SeuHeaderMobile, SeuMainHeader
  },

  data: () => ({
    menuOpened: false,
    showPopup: false,
    popup: null
  }),

  metaInfo() {
    switch (this.$store.state.currentLanguage) {
      case 'EN' :
        return {
          title: 'Swiss Engineers United: By engineers, for engineers.', //default title
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: ' SEU is the leading Swiss engineering group for construction, geomatics, planning and succession solutions. We’ll lead your company into the future.',
            }
          ],
          htmlAttrs: {
            lang: this.$store.state.currentLanguage.toLowerCase()
          },
        };
      case 'DE' :
        return {
          title: 'Swiss Engineers United: Von Ingenieuren für Ingenieure.',
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: 'SEU ist die führende Schweizer Engineering-Gruppe für Bau, Geomatik, Planung und erfolgreiche Nachfolgelösungen. Wir führen Ihr Unternehmen in die Zukunft.',
            }
          ],
          htmlAttrs: {
            lang: this.$store.state.currentLanguage.toLowerCase()
          },
        }


    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.currentLanguage.toLowerCase(),
      defaultLanguage: state => state.defaultLanguage.toLowerCase()
    }),
    paramLang() {
      return this.currentLanguage !== this.defaultLanguage ? this.currentLanguage : null
    },

    cookiesBannerContent() {
      return require(`./services/pages/${this.$store.state.currentLanguage.toLowerCase()}/cookiesBanner.js`).default;
    },

    termsContent() {
      return require(`./services/pages/${this.$store.state.currentLanguage.toLowerCase()}/terms.js`).default;
    },
  },

  methods: {
    openPopup(data) {
      console.log('OPEN POPUP', data)
      this.popup = data;
      this.showPopup = true;
    },
    selectLanguage(lang) {
      const addLangParam = this.defaultLanguage !== lang.key.toLowerCase()
      const params = {
        ...this.$route.params,
        ...addLangParam ? {lang: lang.key.toLowerCase()} : {lang: null}
      }
      if (params.slug) {
        let currentPageRouteKey = Object.keys(navigationMenu).find(pageKey => {
          return navigationMenu[pageKey].route.name === this.$route.name
        });
        if (currentPageRouteKey) {
          params.slug = navigationMenu[currentPageRouteKey][lang.key.toLowerCase()].slug
        }
      }
      this.$store.commit('setCurrentLanguage', lang.key)

      this.$i18n.locale = lang.key.toLowerCase()
      this.$router.replace({
        name: this.$route.name,
        params
      }).catch(err => {
        console.warn(err);
      })
    },
    setDocumentHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      // document.documentElement.style.setProperty('overflow', `hidden`);
    },
  },

  mounted() {
    this.setDocumentHeight();
    window.addEventListener('resize', this.setDocumentHeight, false);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setDocumentHeight, false);
    document.documentElement.style.removeProperty('--vh');
  }
}
</script>

<style lang="scss">
@import "css/app";
</style>
